import api from "../../infra/api";

class ConsultaDisponibilidade {
    async BuscarPontos(dto) {
        const response = await api({
            method: "POST",
            url: 'api/v1/ConsultaDeDisponibilidade/BuscarPontos',
            data: dto
        });

        return response.data;
    }

    async BuscarParametros() {
        const response = await api({
            method: "GET",
            url: '/api/v1/ConsultaDeDisponibilidade/BuscarParametros?page=1&start=0&limit=999'
        });

        return response.data;
    }
}

export default new ConsultaDisponibilidade();